<fw-dialog width="small">
  <fw-dialog-header>
    <h3>{{ (this.data.header ?? 'importReportDialog.header' ) | translate }}</h3>
  </fw-dialog-header>
  <fw-dialog-content>
    <form [formGroup]="reportSettings" class="column">
      <label>{{ (this.data.label  ?? 'importReportDialog.form.format.label' ) | translate }}</label>
      <fw-select width="100%" formControlName="format" [options]="formatOptions" test-id="importReportFormat">
      </fw-select>
    </form>
  </fw-dialog-content>
  <fw-dialog-actions>
    <fw-button test-id="download" (click)="downloadReport()" [disabled]="loading">
      <div>
        <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
        <span>{{ (loading ? 'importReportDialog.states.generating' : 'common.actions.download') | translate }}</span>
      </div>
    </fw-button>
  </fw-dialog-actions>
</fw-dialog>
